import { Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {DirectValueFactory, Environment, ENVIRONMENT, IntegrationAuthRequest, IntegrationAuthResponse, ScimIntegration, ScimMappingConfig, ValueMapping} from "@netfoundry-ui/shared/model";
import { ScimIntegrationService } from '@netfoundry-ui/shared/apiv2';

import {isEmpty, unset} from 'lodash';
import { ApiService } from '@netfoundry-ui/shared/services';
import { GrowlerData, GrowlerService } from '@netfoundry-ui/shared/growler';
import { Subject } from "rxjs";


class ProgressMeterStep {
  index = 0;
  label = '';
  state: '' | 'TO_DO' | 'IN_PROGRESS' | 'COMPLETE' | 'ERROR' | 'WARNING' = '';
};

class ProgressWizardStep {
  index = 0;
  label = '';
  subLabel = '';
};


@Component({
    selector: 'lib-scim-integration-create-form',
    templateUrl: './scim-integration-create-form.component.html',
    styleUrls: ['./scim-integration-create-form.component.scss'],
    standalone: false
})
export class ScimIntegrationCreateFormComponent implements OnInit {

  steps: ProgressWizardStep[] = [];
  progressSteps: ProgressMeterStep[] = [];
  currentStepIndex = 0;

  title = 'Create Integration';
  subtitle = 'Provide a name for your Integration';
  backButtonLabel = 'Back';
  nextButtonLabel = 'Next';
  nextButtonDisabled = false;
  backButtonDisabled = false;
  titleImageSrc = '';
  showCloseButton = true;
  
  close = new EventEmitter<any>;
  done = new EventEmitter<any>;

  displayDoneButton = false;
  formData: any = {};
  
  errMap: any = {};
  integrationUrl: string;
  currentNetwork: any;
  protected isLoading = false;
  saveSubject = new Subject<boolean>;
  mappingConfigUpdateSubject = new Subject<boolean>;

  authToken: any;

  
  getProgressBarStyle(index: number) {
    const step = this.progressSteps[index];
    const nextStep = this.progressSteps[index + 1];
    if (step?.state === 'COMPLETE' && nextStep?.state === 'COMPLETE') {
      return true;
    }
    return false;
  }

  wiardStepIndex = 0;
  wizardSteps: ProgressWizardStep[] = [
    {
      index: 0,
      label: 'Create Integration',
      subLabel: 'Provide a name for your Integration'
    },
    {
      index: 1,
      label: 'Update Mapping Config',
      subLabel: 'Configure how the properties from your identities are mapped to Ziti identities'
    },
    {
      index: 2,
      label: 'Generate Authentication',
      subLabel: 'Configure your IDP to sync identities via SCIM using your Integration URL and the generated Bearer token'
    }
  ];

  meterSteps: ProgressMeterStep[] = [
    {
      index: 0,
      label: 'Create Integration',
      state: 'TO_DO'
    },
    {
      index: 1,
      label: 'Update Mapping Config',
      state: 'TO_DO'
    },
    {
      index: 2,
      label: 'Generate Authentication',
      state: 'TO_DO'
    }
  ];

    constructor(
      private apiService: ApiService,
      public svc: ScimIntegrationService,
      private growlerService: GrowlerService,
      private dialogRef: MatDialogRef<ScimIntegrationCreateFormComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      @Inject(ENVIRONMENT) public environment: Environment,
    ) {

      this.steps = this.wizardSteps;
      this.progressSteps = this.meterSteps;

      this.formData = new ScimIntegration();
    }
  ngOnInit(): void {
    this.apiService.currentNetwork.pipe().subscribe((network) => {
      this.currentNetwork = network;
    });
  }

    wizardStepChanged(step: ProgressWizardStep) {
      if (step.index < (this.wizardSteps.length - 1)) {
        this.nextButtonLabel = 'Next';
      } else if (this.wiardStepIndex >= (this.wizardSteps.length - 1) && this.meterSteps[this.meterSteps.length - 1].state !== 'COMPLETE') {
        this.nextButtonLabel = 'Save';
      } else if (this.meterSteps[this.meterSteps.length - 1].state === 'COMPLETE') {
        this.nextButtonLabel = 'Done';
      }

      this.title = step.label;
      this.subtitle = step.subLabel;
    }

    cancel() {
        this.dialogRef.close(false);
    }

  nextStep() {

    switch(this.currentStepIndex) {
      case 0:
        this.saveScimIntegration();
        break;
      case 1:
        this.updateMappingConfig();
        break;
      case 2:
        this.cancel();
        break;
      default:
        if (this.currentStepIndex >= (this.steps.length - 1)) {
          this.done.emit();
          return;
        }
        this.currentStepIndex++;
        this.wizardStepChanged(this.steps[this.currentStepIndex]);
        break;
    }

    
    
  }

  goToStep(stepNum: ProgressWizardStep) {
    this.currentStepIndex = stepNum.index;
  }

  prevStep() {
    this.currentStepIndex--; 
  }

  get progressTrackHeight() {
    const heightfactor = 8.333;
    const trackNumber = ((this.steps ? this.steps.length : 1) - 1);
    const trackHeight = heightfactor * trackNumber;
    return trackHeight + 'rem';
  }

  saveScimIntegration() {

    if(!isEmpty(this.formData.name)) {
      this.formData.name = this.formData.name.trim();
    }

    if(isEmpty(this.formData.id)) {
      this.formData.networkId = this.currentNetwork.id;
      this.formData.networkGroupId = this.currentNetwork.networkGroupId;
    }
    
    if(!this.validate()) {
      return;
    }

    this.isLoading = true;
    this.backButtonDisabled = true;
    this.nextButtonDisabled = true;

     this.svc.save(this.formData).then((result) => {

      if(result.length > 0) {
        this.errMap = this.processErrors(result);
        return false;
      }


      this.formData = result;

        this.entityUpdated();
        
      return true;
    }).then((result) => {
        this.isLoading = false;
        this.backButtonDisabled = false;
        this.nextButtonDisabled = false;
      if(result) {
        this.meterSteps[0].state = "COMPLETE";
        this.currentStepIndex++;
        this.wizardStepChanged(this.steps[this.currentStepIndex]);
      }
    })
  }

    entityUpdated() {
    if (this.formData.id) {
    }
    
    unset(this.formData, '_links');
  }

  validate() {
    this.errMap = {};
    if (isEmpty(this.formData.name)) {
      this.errMap['nameRequired'] = true;
    }
    
    return isEmpty(this.errMap);
  }

  
  updateMappingConfig() {
    this.saveSubject.next(true);

    
    const updateMappingConfigPromise = new Promise((resolve) => {
      this.mappingConfigUpdateSubject.subscribe((wasUpdated: boolean) =>{
        resolve(wasUpdated);
      });
    });

    updateMappingConfigPromise.then((result) => {
        this.isLoading = false;
        this.backButtonDisabled = false;
        this.nextButtonDisabled = false;

        if(result) {
          this.meterSteps[1].state = "COMPLETE";
          this.currentStepIndex++;
          this.wizardStepChanged(this.steps[this.currentStepIndex]);
        }
    })
  }

  onGenerateAuthToken(wasSuccessful: boolean) {
    if(wasSuccessful) {
        this.getIntegration();
        this.meterSteps[2].state = "COMPLETE";
        this.wizardStepChanged(this.steps[this.currentStepIndex]);
        this.displayDoneButton = true;
    }
  }

  getIntegration() {
    return this.svc.getIntegration(this.formData.id).then((entity: ScimIntegration) => {
      this.formData = entity
      this.entityUpdated();
      return entity; 
    });
  }
  
  private processErrors(errors: any) {

    // handle system error
    if(errors[0] ['http'] || errors[0] ['invalid']) {
      this.growlerService.show(
          new GrowlerData(
          'error',
          'SCIM Integration update request failed. ',
          errors[0] ['http']?.message ?? errors[0] ['invalid']
          )
      );
      return {};
    } else {
      const errorMap: any = {};
      errors.forEach((err: any) => {
          errorMap[err.label] = err.message;
      })

      return errorMap;

    }
  }

  mappingConfigUpdateHandler(wasUpdated: boolean) {
    this.mappingConfigUpdateSubject.next(wasUpdated);
  }
}
